export const LOADING_PUBLIC_TOURNAMENTS = 'LOADING_PUBLIC_TOURNAMENTS';
export const LOADING_PUBLIC_TOURNAMENTS_ERROR = "LOADING_PUBLIC_TOURNAMENTS_ERROR";
export const LOADED_PUBLIC_TOURNAMENTS = "LOADED_PUBLIC_TOURNAMENTS"; 
export const PUBLIC_TOURNAMENTS_END_REACHED = "PUBLIC_TOURNAMENTS_END_REACHED";
export const CLEAR_PUBLIC_TOURNAMENTS = "CLEAR_PUBLIC_TOURNAMENTS";

export const LOADED_PUBLIC_CURRENT = "LOADED_PUBLIC_CURRENT";
export const LOADING_PUBLIC_CURRENT = "LOADING_CURRENT_PUBLIC";
export const LOADING_PUBLIC_CURRENT_ERROR = "LOADING_PUBLIC_CURRENT_ERROR"